import Card from "../Card";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ReviewComplete.module.css";
import trustpilotLogo from "../../images/trustpilotLogo.svg";
import usePageView from "../../lib/usePageView";

const strings = {
    header: "1st Financial Bank USA",
    review: "Thank you for reviewing your 1st Financial Bank USA Card Application!",
    subtitle: "1fbusa.com",
    title: "1st Financial Bank USA Review Complete",
};

export default function ReviewComplete() {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);

    return (
        <div className={styles.wrapper}>
            <div className={styles.firstContainer}>
                <div className={styles.logoContainer}>
                    <img className={styles.logo} alt="TrustPilot Reviews" src={trustpilotLogo} />
                </div>
            </div>
            <div className={styles.breadcrumb}>
                <div className={styles.businessInfo}>
                    <img
                        alt=""
                        src={`${process.env.REACT_APP_BASE_PATH}/default_logo.svg`}
                        className={styles.businessLogo}
                    />
                    <div>
                        <div className={styles.header}>{strings.header}</div>
                        <div className={styles.subtitle}>{strings.subtitle}</div>
                    </div>
                </div>
            </div>

            <div className={styles.body}>
                <Card>
                    <div>{strings.review}</div>
                </Card>
            </div>
        </div>
    );
}
